import React from 'react'
import {
  EditableReactSelect,
  EditableReactSelectCreatable,
  EditableSwitch,
  EditableTextField,
} from '../common/EditableComponents'
import GooglePlacesAddress from '../common/GooglePlacesAddress'
import EditActionComponent from '../common/EditActionComponent'
import { TableRow, TableCell, Button, LinearProgress } from '@material-ui/core'
import { consumerTypes } from '../../utils/common'

const RegionBaseItem = (props) => {
  const {
    data,
    selectedZoneType,
    regionZoneTypes,
    loading,
    hasAccess,
    selectedKmlEdge,
    editMode,
    onChange,
    onChangeAddress,
    onChangeZoneType,
    handleButtonFile,
    setStateLoading,
    onChangeKmlEdge,
    formatKmlEdges,
    deleteKmlFile,
    onChangeZipcodes,
    onSave,
    onCancel,
    onDelete,
    location,
    enableEdit,
    onChangeAllowedConsumerType,
    regionConsumerTypeFlag,
  } = props
  const selectedConsumerTypes =
    (data &&
      data.allowedConsumerTypes &&
      data.allowedConsumerTypes.length &&
      data.allowedConsumerTypes.map((consumerType) =>
        consumerTypes.find((ct) => ct.value === consumerType),
      )) ||
    []
  const allowedConsumerTypesStr =
    selectedConsumerTypes && selectedConsumerTypes.map((item) => item.label).join(', ')
  return (
    <TableRow>
      <TableCell>
        <EditableTextField
          valueToRender={data.name}
          editMode={editMode}
          value={data.name}
          onChange={onChange('name')}
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
          placeholder={'Region Name'}
        />
      </TableCell>
      <TableCell>
        {editMode ? (
          <GooglePlacesAddress updateAddress={onChangeAddress('location')} value={location} />
        ) : (
          <span>{location}</span>
        )}
      </TableCell>
      <TableCell className="cell-wrap-word">
        <EditableReactSelectCreatable
          value={selectedZoneType}
          onChange={onChangeZoneType}
          valueToRender={(selectedZoneType && selectedZoneType.label) || '--'}
          editMode={editMode}
          options={regionZoneTypes || []}
          placeholder="Select Type"
        />
      </TableCell>
      {data.zoneType === 'kml' ? (
        <TableCell className="cell-wrap-word" style={{ minWidth: '195px' }}>
          {editMode ? (
            <div>
              <label className="kml-file kml-file-upload">
                <input
                  type="file"
                  accept=".kml"
                  editMode={editMode}
                  onChange={(e) => {
                    handleButtonFile(e, data)
                    ;(e.target.value = null), setStateLoading(true)
                  }}
                  hidden
                />
                <i className="fa fa-cloud-upload" /> Add KML-File
              </label>
              <label
                className="kml-file kml-file-delete"
                onClick={() => {
                  deleteKmlFile && deleteKmlFile(data, selectedKmlEdge)
                }}
              >
                <i className="fa fa-cloud-upload" /> Delete KML-File
              </label>
              {loading && <LinearProgress color="primary" />}
              <div style={{ height: '4px' }} />
              <EditableReactSelect
                multi={false}
                value={{ label: selectedKmlEdge.name, value: selectedKmlEdge }}
                onChange={onChangeKmlEdge}
                editMode={editMode}
                options={formatKmlEdges(data.kmlEdges)}
                placeholder="Select KML"
              />
            </div>
          ) : (
            <span style={{ fontStyle: !selectedKmlEdge.name && 'italic' }}>
              {selectedKmlEdge.name || 'No KML found'}
            </span>
          )}
        </TableCell>
      ) : (
        <TableCell className="cell-wrap-word">
          <EditableReactSelectCreatable
            multi={true}
            value={
              (data.zipCodes &&
                data.zipCodes.map((zipcode) => ({
                  label: zipcode,
                  value: zipcode,
                }))) ||
              []
            }
            onChange={onChangeZipcodes}
            valueToRender={
              (data.zipCodes && data.zipCodes.length && data.zipCodes.join(', ')) || ''
            }
            editMode={editMode}
            options={[]}
            placeholder="Enter Zipcodes"
          />
        </TableCell>
      )}
      {regionConsumerTypeFlag && (
        <TableCell>
          <EditableReactSelect
            multi={true}
            valueToRender={allowedConsumerTypesStr}
            editMode={editMode}
            value={selectedConsumerTypes}
            onChange={onChangeAllowedConsumerType}
            clearable={true}
            options={consumerTypes.length !== selectedConsumerTypes.length ? consumerTypes : []}
          />
        </TableCell>
      )}
      <TableCell>
        <EditableSwitch
          valueToRender={data.active ? 'Enabled' : 'Disabled'}
          checked={data.active}
          editMode={editMode}
          onChange={onChange('active', true)}
        />
      </TableCell>
      {hasAccess() ? (
        <TableCell>
          <EditActionComponent
            onSave={onSave}
            onCancel={onCancel}
            onEdit={enableEdit}
            editMode={editMode}
          />
          {!editMode ? (
            <Button className="danger-button margin" onClick={onDelete}>
              Delete
            </Button>
          ) : null}
        </TableCell>
      ) : null}
    </TableRow>
  )
}

export default RegionBaseItem



// WEBPACK FOOTER //
// ./src/components/Regions/RegionBaseItem.js